const textEncoder = new TextEncoder();
function normalize(value) {
    if (value === null || typeof value === "string" || typeof value === "boolean")
        return value;
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            throw new TypeError("Canonical JSON rejects non-finite numbers");
        return Object.is(value, -0) ? 0 : value;
    }
    if (Array.isArray(value))
        return value.map(normalize);
    if (typeof value === "object") {
        const record = value;
        const result = {};
        for (const key of Object.keys(record).sort()) {
            const child = record[key];
            if (child !== undefined)
                result[key] = normalize(child);
        }
        return result;
    }
    throw new TypeError(`Canonical JSON cannot encode ${typeof value}`);
}
export function canonicalJson(value) {
    return JSON.stringify(normalize(value));
}
export function canonicalBytes(value) {
    return textEncoder.encode(canonicalJson(value));
}
export function messageAad(input) {
    return canonicalBytes({
        domain: "baton.message",
        formatVersion: input.formatVersion,
        keyEpoch: input.keyEpoch,
        messageType: input.messageType,
        objectId: input.objectId,
    });
}
export function completionResultAad(input) {
    return canonicalBytes({
        domain: "baton.message-result",
        formatVersion: input.formatVersion,
        keyEpoch: input.keyEpoch,
        messageId: input.messageId,
        messageType: input.messageType,
        recipientAgentId: input.recipientAgentId,
    });
}
export function briefingMacPayload(input) {
    if (!Number.isSafeInteger(input.revision) || input.revision < 1) {
        throw new TypeError("Briefing revision must be a positive safe integer");
    }
    return canonicalBytes({
        domain: "baton.briefing-mac",
        id: input.id,
        revision: input.revision,
        text: input.text,
    });
}
export function blobAad(input) {
    return canonicalBytes({
        domain: "baton.blob",
        formatVersion: input.formatVersion,
        keyEpoch: input.keyEpoch,
        kind: input.kind,
        objectId: input.objectId,
    });
}
/**
 * AAD for a mutable encrypted column. `revision` is the independently stored,
 * monotonically increasing row/field revision. Callers must supply the current
 * trusted revision when decrypting; accepting the value from a replayed
 * envelope would defeat rollback protection.
 */
export function mutableFieldAad(input) {
    if (!Number.isSafeInteger(input.revision) || input.revision < 1) {
        throw new TypeError("Mutable ciphertext revision must be a positive safe integer");
    }
    return canonicalBytes({
        domain: "baton.mutable-field",
        field: input.field,
        formatVersion: input.formatVersion,
        keyEpoch: input.keyEpoch,
        objectId: input.objectId,
        revision: input.revision,
    });
}
//# sourceMappingURL=canonical.js.map